// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCS9so24g3T3YgfM65W59IQfwOuEnK5rP0',
  authDomain: 'hifix-db.firebaseapp.com',
  projectId: 'hifix-db',
  storageBucket: 'hifix-db.appspot.com',
  messagingSenderId: '156541167436',
  appId: '1:156541167436:web:e7fb226307d49dc84391e9',
  measurementId: 'G-YGG2JM4NFZ',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
// const analytics = getAnalytics(app);
